import { useApi } from '@/api';
import type { GetBranchComparisonResponse } from '@/api/handlers/resources/sales/responses/GetBranchComparisonResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export type UseBranchComparisonQueryParams = {
    from: string;
    to: string;
};

/**
 * Branch-comparison query. The `queryKey` carries `from` / `to` so
 * changing the page-level period filter triggers a refetch
 * automatically.
 */
export const useBranchComparisonQuery = (
    params: UseBranchComparisonQueryParams,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetBranchComparisonResponse>>({
        queryKey: SalesQueryKeys.branchComparison(params.from, params.to),
        queryFn: () =>
            apiClient.sales.getBranchComparison({
                from: params.from,
                to: params.to,
            }),
        enabled,
        staleTime: 60_000,
    });
};
